import React from 'react';
import { useTranslation } from 'react-i18next';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const { t } = useTranslation();

  if (totalPages <= 1) return null;

  return (
    <div className='flex items-center justify-center gap-4 mt-8'>
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className='px-4 py-2 rounded-lg text-sm font-medium bg-white border border-slate-300 text-gray-700 hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition'
      >
        {t('common.previous')}
      </button>
      <span className='text-sm text-gray-600'>
        {t('common.page_of', { current: currentPage, total: totalPages })}
      </span>
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className='px-4 py-2 rounded-lg text-sm font-medium bg-white border border-slate-300 text-gray-700 hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition'
      >
        {t('common.next')}
      </button>
    </div>
  );
};
